// extracted by mini-css-extract-plugin
export default {"markRow":"jcgFyzdROSDB6be3r1aw"};